<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" v-loading="loading">
      <!-- 复查列表 strat -->
      <el-tab-pane label="复查前后对比图" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.datatype" placeholder="请选择" class="select"  style="width: 200px;" @change="handleSelectChange">
              <el-option label="远用裸眼视力" value="1"></el-option>
              <el-option label="NRA" value="2"></el-option>
              <el-option label="PRA" value="3"></el-option>
              <el-option label="调节灵敏度" value="4"></el-option>
              <el-option label="AMP" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- <el-button type="primary" @click="clicksearch">查询</el-button> -->
            <el-button type="info" @click="backCustomerManagement">返回</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <ve-line
        v-if="lineDataLoaded"
        :data="QuXianData"
        :colors="QuXianColors">
        </ve-line>

        <el-table :data="dataList" border stripe class="mt15">
          <el-table-column prop="Yanguangriqi" label="日期" width="300px"></el-table-column>
          <el-table-column prop="Od" label="右眼OD" width="200px"></el-table-column>
          <el-table-column prop="Os" label="左眼OS" width="200px"></el-table-column>
          <el-table-column prop="Ou" label="双眼OU" width="300px"></el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 复查列表 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      activeName: 'first',
      keywords: {
        datatype: '1'
      },
      loading: false,
      dataList: [],
      glassuserid: 0,
      //曲线图
      lineDataLoaded: false,
      QuXianData: {
        columns: ['日期', '右眼OD', '左眼OS', '双眼OU'],
        rows: []
      },
      QuXianColors: ['#00A7FB','#FF713E','#FFAA2E'],
    }
  },
  mounted () {
  },
  methods: {
    handleSelectChange(value) {
      this.apiGetErp7ShiGuangYanGuangJianChaList2()
    },
    // clicksearch () {
    //   this.apiGetErp7ShiGuangYanGuangJianChaList2()
    // },
    LoadData (id) {
      this.dataList = []
      this.glassuserid = id
      this.apiGetErp7ShiGuangYanGuangJianChaList2()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    apiGetErp7ShiGuangYanGuangJianChaList2: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.glassuserid,
        datatype: that.keywords.datatype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp7ShiGuangYanGuangJianChaList2, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.processQuXianData()
          }
          console.log(response.data)
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    processQuXianData(){
      var list = [];
      for (let i = 0; i < this.dataList.length; i++) {
        list.push({
          日期: this.dataList[i].Yanguangriqi,
          右眼OD: this.dataList[i].Od,
          左眼OS: this.dataList[i].Os,
          双眼OU: this.dataList[i].Ou});
      }
      this.QuXianData.rows = list;
      this.lineDataLoaded = true;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
